import {ChangeDetectorRef,Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import { AppService } from '../../../../services/app.service';
import { UtilitaryService } from '../../../../services/utilitary.service';
import { StateService } from '../../../../services/state.service';
import { DroitsService } from '../../../../services/droits.service';

@Component({
  selector: 'formulaire-dossier-dialog',
  templateUrl: './formulaire-dossier-dialog.component.html',
  styleUrls: ['./formulaire-dossier-dialog.component.scss']
})
export class FormulaireDossierDialogComponent implements OnInit {
  droits: any = [];
  rights: any = [];
  forms: any[];
  result: any = {
    id: "",
    selectedForm: {}
  };
  selectedForm: boolean = false;
  
  search: any;
  formsFilters: any[];
  constructor(
    public dialogRef: MatDialogRef<FormulaireDossierDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appService: AppService,
    public utilities: UtilitaryService,
    private stateService: StateService,
    public droitsService: DroitsService,
    private changeDetectorRef: ChangeDetectorRef,
) { 
	

}

  ngOnInit() {
    this.result = {
      id: "",
      selectedForm: {}
    };
    this.droits = this.data.droits;
    if (this.data.rights!=undefined)
    	this.rights=this.data.rights;
    
    this.stateService.demandeType.subscribe((demandeTypes) => {
      console.log(demandeTypes, this.data.instruction);
      this.forms = [];
	  this.formsFilters=[];
      demandeTypes.forEach(element => {
        if(element.ID === this.data.instruction.demande.type.ID)
        {
          element.forms.forEach((form) => {
            form.selected = false;
            form.readAndAdd=true;
             
            if (form.key !=undefined 
			  && form.key
			  && this.rights!=undefined
			  && this.rights[form.key]!=undefined
			  && this.rights[form.key].w!=undefined	
			  )
			  	form.readAndAdd=this.rights[form.key].w;
			  	
			  if (
				   form.readAndAdd 
				&&  form.key !=undefined 
			  && form.key
			  && this.droits!=undefined
			  && this.droits[form.key]!=undefined
			  && this.droits[form.key].c!=undefined	
			  )
				  form.readAndAdd=this.droits[form.key].c;
				
              
           // console.log("right FormulaireDossierDialogComponent",form.key,form.readAndAdd,this.rights[form.key],this.droits[form.key]);
            
            if(this.data.typeForm && form.type === this.data.typeForm)
              this.forms.push(form);
            else if(!this.data.typeForm && (form.type === 0 || form.type === 3))
              this.forms.push(form);
            else if(!this.data.typeForm && form.type === 2)
              this.forms.push(form);
            else if(!this.data.typeForm && form.type === 5)
              this.forms.push(form);
          });
        
        }
      });
	  this.formsFilters=[...this.forms];
        console.log("FormulaireDossierDialogComponent",this.forms,this.formsFilters) 
         this.changeDetectorRef.detectChanges();
    });
  }

  setSelectedForm(){
    console.log(this.result.selectedForm);
    this.selectedForm = false;
    this.forms.forEach((form) => {
      if(form.selected)
        this.selectedForm = true;
    })
  }
  
  filterResults() {
     		    if (!this.search) {
     		      this.formsFilters = [...this.forms];
     		    } else {
     		      this.formsFilters = [];
     		      this.formsFilters = this.forms.filter((form) => {
     		        return form.libelle.toUpperCase().indexOf(this.search.toUpperCase()) > -1;
     		      });
     		    }
    }
}
